import React from 'react';
import './MarqueeText.css';

export default function MarqueeText({ text, dark = true, speed = 30 }) {
  const repeated = Array(6).fill(text).join(' — ');

  return (
    <div className={`marquee ${dark ? 'marquee--dark' : 'marquee--light'}`}>
      <div className="marquee__track" style={{ animationDuration: `${speed}s` }}>
        <span>{repeated}</span>
        <span aria-hidden="true">{repeated}</span>
      </div>
    </div>
  );
}
